import { PencilSimpleIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import { editableFieldLabel } from 'app/lib/workflows/actionCatalogs'
import type { EditObjectFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Edits one or more fields on the contact. */
export function EditObjectNode({ data, selected }: NodeProps<EditObjectFlowNode>) {
  const on = data.target === `activity` ? ` on activity` : ` on contact`
  // Rows with no field chosen yet aren't writes, so they don't count here — a freshly dropped node
  // reads "No field selected" rather than promising a change it isn't configured to make.
  const [first, ...rest] = data.fields.filter((row) => row.field)
  // A card this narrow can name one field or count several, not both. Naming the single case keeps
  // the common step readable; the count tells the multi-field case it has more than the inspector
  // used to be able to hold.
  const summary = !first
    ? `No field selected`
    : rest.length
      ? `Updates ${rest.length + 1} fields${on}`
      : `${first.operation === `clear` ? `Clear` : `Set`} ${editableFieldLabel(first.field) ?? first.field}${on}`
  return (
    <NodeShell
      icon={PencilSimpleIcon}
      accent="cyan"
      kind="Edit"
      label={data.label}
      description={summary}
      selected={selected}
    />
  )
}
